import { Col, GRID } from '../../components/custom';

export default function ATU()
{
    return (
        <Col id='ATU' className='usecase'>
            <Col className='banner'>
                <span className='title'>Use Case: ATU (Awareness, Trial, Usage) Tracking in Pharma</span>
            </Col>
            <Col className='section objective'>
                <span className='title'>Objective</span>
                <span className='descsmall'>To evaluate the <strong>awareness, trial, and usage patterns</strong> of competing pharmaceutical brands among healthcare professionals (HCPs), identify drivers of adoption, and segment HCPs for targeted strategy.</span>
            </Col>
            <Col className='section methodology'>
                <span className='title'>Methodology</span>
                <Col className='notTitle'>
                    <Col className='part'>
                        <span className='desc'>Data Source</span>
                        <span className='descsmall'>Quantitative survey of 300 physicians across multiple specialties and regions.</span>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Key Variables</span>
                        <ul>
                            <li className='descsmall'><strong>Aided Awareness</strong> of Brand A, B, C</li> 
                            <li className='descsmall'><strong>Trial Status</strong> - whether HCP has prescribed the brand</li>
                            <li className='descsmall'><strong>Current Usage</strong> - whether brand is currently prescribed regularly</li>
                            <li className='descsmall'><strong>Other Factors:</strong> Specialty, Region, Rep Visit in past 3 months, Efficacy Perception</li>
                        </ul>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Analytical Techniques Used</span>
                        <ul>
                            <li className='descsmall'><strong>Cross-tabulation:</strong> Awareness, trial, and usage by region and specialty</li> 
                            <li className='descsmall'><strong>Statistical Tests:</strong> Chi-square test for group differences</li>
                            <li className='descsmall'><strong>Predictive Modeling:</strong> Logistic regression to identify drivers of Brand A trial</li>
                            <li className='descsmall'><strong>Segmentation:</strong> KMeans clustering based on ATU patterns</li>
                            <li className='descsmall'><strong>Visualization:</strong> Heatmaps and bar charts to summarize insights</li>
                        </ul>
                    </Col>
                </Col>
            </Col>
            <Col className='section results'>
                <span className='title'>Key Findings</span>
                <Col className='notTitle'>
                    <Col className='part'>
                        <span className='desc'>Awareness & Adoption</span>
                        <GRID className='_4x4'>
                            <span className='descsmall bold'>Metric</span>
                            <span className='descsmall bold'>Brand A</span>
                            <span className='descsmall bold'>Brand B</span>
                            <span className='descsmall bold'>Brand C</span>
                            <span className='descsmall bold left'>Aided Awareness</span>
                            <span className='descsmall'>~70%</span>
                            <span className='descsmall'>~60%</span>
                            <span className='descsmall'>~40%</span>
                            <span className='descsmall bold left'>Trial Rate</span>
                            <span className='descsmall'>~52%</span>
                            <span className='descsmall'>~38%</span>
                            <span className='descsmall'>~22%</span>
                            <span className='descsmall bold left'>Usage Rate</span>
                            <span className='descsmall'>~34%</span>
                            <span className='descsmall'>~25%</span>
                            <span className='descsmall'>~10%</span>
                        </GRID>
                        <ul>
                            <li className='descsmall'><strong>Brand A</strong> leads in awareness and trial, but retention (usage) drops, indicating an opportunity for better value communication.</li> 
                            <li className='descsmall'><strong>Brand C</strong> has low awareness but a niche group of loyal users.</li>
                        </ul>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Statistical Insights | Logistic Regression (Brand A Trial):</span>
                        <GRID className='_3x3'>
                            <span className='descsmall bold'>Variable</span>
                            <span className='descsmall bold'>Coefficient</span>
                            <span className='descsmall bold'>P-Value</span>
                            <span className='descsmall bold left'>Efficacy Perception</span>
                            <span className='descsmall'>Not significant (p {'>'} 0.05)</span>
                            <span className='descsmall'></span>
                            <span className='descsmall bold left'>Rep Visit (last 3 months)</span>
                            <span className='descsmall'>Not significant (p {'>'} 0.05)</span>
                            <span className='descsmall'></span>
                        </GRID>
                        <span className='descsmall'>Indicates that other factors may drive trial more than rep interactions or general perception in this dataset.</span>
                        <span className='desc'>Chi-Square Test:</span>
                        <ul><li className='descsmall'>No significant difference in Brand A trial rates across regions (p = 0.35)</li></ul>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Segmentation Insights (KMeans Clustering)</span>
                        <GRID className='_2x3'>
                            <span className='descsmall bold'>Segment</span>
                            <span className='descsmall bold'>Characteristics</span>
                            <span className='descsmall bold'>0</span>
                            <span className='descsmall'>Moderate trial; high Brand C usage → Brand C loyalists</span>
                            <span className='descsmall bold'>1</span>
                            <span className='descsmall'>High Brand A usage, low Brand C → Brand A adopters</span>
                            <span className='descsmall bold'>2</span>
                            <span className='descsmall'>Balanced adoption across brands → Brand B engaged segment</span>
                        </GRID>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Strategic Recommendations</span>
                        <ul>
                            <li className='descsmall'><strong>Segment 0:</strong> Highlight Brand A's differentiation against Brand C through efficacy or safety data</li>
                            <li className='descsmall'><strong>Segment 1:</strong> Strengthen retention programs or messaging to maintain loyalty</li>
                            <li className='descsmall'><strong>Segment 2:</strong> Focus education and sampling efforts to convert trial into usage</li>
                        </ul>
                    </Col>
                </Col>
            </Col>
        </Col>
    )
}